import React, { useEffect } from "react";
import { Route, Switch } from "react-router";
import { parse } from "query-string";

import { PageBody, Page, PageHeader, PageFooter } from "@jsluna/site-layout";
import { reportError } from "@jsainsburyplc/id-ui-common";

import { urls } from "utils/urls";
import { isProd } from "utils/env";
import { sanitisePath } from "utils/sanitisePath";
import { CHALLENGE, DATA_CHALLENGE } from "constants/login";

//import useTrackPage from "hooks/useTrackPage";
import useCookies from "hooks/useCookies";

import LoginPage from "pages/LoginPage";
import MyIdConfirmationPage from "pages/MyIdConfirmationPage";
import MyIdEmailVerificationPage from "pages/MyIdEmailVerificationPage";
import MyIdSetPasswordPage from "pages/MyIdSetPasswordPage";
import OtpPage from "pages/OtpPage";
import InitiateRegistrationPage from "pages/InitiateRegistrationPage";
import { ProgressiveRegistration } from "pages/ProgressiveRegistration";
import RegistrationPage from "pages/RegistrationPage";
import RegistrationOtpPage from "pages/RegistrationOtpPage";
import FindOutMorePage from "pages/FindOutMorePage";
import ResetPasswordPage from "pages/ResetPasswordPage";
import ForgottenPasswordPage from "pages/ForgottenPasswordPage";
import ForgottenPasswordOtpPage from "pages/ForgottenPasswordOtpPage";
import InitiateAccountRecoveryPage from "pages/InitiateAccountRecoveryPage";
import AccountRecoveryOtpPage from "pages/AccountRecoveryOtpPage";
import WebAuthnRegistrationPage from "pages/WebAuthnRegistrationPage";
import KeepYourAccountSafePage from "pages/KeepYourAccountSafePage";

import Header from "components/Header";
import Startup from "components/Startup";
import FooterContent from "components/FooterContent";
import AccountConfirmation from "components/Login/Notifications/AccountConfirmation";
import { MultiMissionFooter } from "components/MultiMissionFooter";
import ScrollToTop from "components/ScrollToTop";

const Routes = () => {
  const rootElem = document.querySelector("#root");
  const LOGIN_CHALLENGE_QS = parse(window.location.search)[CHALLENGE];
  const LOGIN_CHALLENGE = rootElem.getAttribute(DATA_CHALLENGE) || "";

  const { loginChallenge, setLoginChallenge } = useCookies();

  //useTrackPage();

  const loginChallengeNotPresent =
    !loginChallenge && !parse(window.location.search)[CHALLENGE];

  useEffect(() => {
    if (isProd() && loginChallengeNotPresent) {
      reportError(
        `Login Challenge not found - ${sanitisePath(window.location.pathname)}`
      );
    }
  }, [loginChallengeNotPresent]);

  useEffect(() => {
    const newLoginChallenge = LOGIN_CHALLENGE_QS || LOGIN_CHALLENGE;
    if (newLoginChallenge) {
      setLoginChallenge(newLoginChallenge, { path: "/" });
    }
  }, [LOGIN_CHALLENGE, LOGIN_CHALLENGE_QS, setLoginChallenge]);

  return (
    <Page>
      <ScrollToTop />
      <PageHeader>
        <Header />
      </PageHeader>
      <PageBody element="main">
        <Startup>
          <Switch>
            <Route exact path={urls.login} component={LoginPage} />
            <Route
              exact
              path={urls.webAuthnAssertionFinish}
              component={LoginPage}
            />
            <Route
              exact
              path={urls.webAuthnRegister}
              component={WebAuthnRegistrationPage}
            />
            <Route
              exact
              path={urls.myIdConfirmationSamePassword}
              render={() => <MyIdConfirmationPage passwordConflict={false} />}
            />
            <Route
              exact
              path={urls.myIdEmailVerification}
              component={MyIdEmailVerificationPage}
            />
            <Route
              exact
              path={urls.myIdSetPassword}
              component={MyIdSetPasswordPage}
            />
            <Route
              exact
              path={urls.myIdConfirmationDiffPassword}
              render={() => <MyIdConfirmationPage passwordConflict={true} />}
            />
            <Route path={urls.otp} component={OtpPage} />
            <Route
              path={urls.activateAccount}
              component={AccountConfirmation}
            />
            <Route
              exact
              path={urls.forgottenPassword}
              component={ForgottenPasswordPage}
            />
            <Route
              path={urls.forgottenPasswordOtp}
              component={ForgottenPasswordOtpPage}
            />
            <Route
              path={urls.initiateAccountRecovery}
              component={InitiateAccountRecoveryPage}
            />
            <Route
              path={urls.accountRecoveryOtp}
              component={AccountRecoveryOtpPage}
            />
            <Route
              path={[urls.resetPassword, urls.resetPasswordNoToken]}
              render={(props) => <ResetPasswordPage {...props} />}
            />
            <Route
              path={urls.initiateRegistration}
              component={InitiateRegistrationPage}
            />
            <Route
              path={urls.registrationOtp}
              component={RegistrationOtpPage}
            />
            <Route path={urls.register} component={RegistrationPage} />
            <Route path={urls.findOutMore} component={FindOutMorePage} />
            <Route
              path={urls.keepYourAccountSafe}
              component={KeepYourAccountSafePage}
            />
            <Route
              path={urls.progressiveRegistration}
              component={ProgressiveRegistration}
            />
          </Switch>
        </Startup>
      </PageBody>
      <PageFooter element="footer">
        <Switch>
          <Route
            path={[
              urls.forgottenPassword,
              urls.forgottenPasswordOtp,
              urls.findOutMore,
              urls.progressiveRegistration,
              urls.resetPassword,
              urls.initiateAccountRecovery,
              urls.accountRecoveryOtp,
              urls.register,
            ]}
            component={MultiMissionFooter}
          />
        </Switch>
        <div className="ln-c-footer ln-u-soft-ends-xl">
          <FooterContent />
        </div>
      </PageFooter>
    </Page>
  );
};

export default Routes;
